/**
 * EN / ع segmented switch. Two options only, so a segmented control beats a
 * menu: the alternative is always one click away and always visible.
 */

import { useI18n } from '@/contexts/I18nContext';
import { cn } from '@/lib/utils';

export function LangToggle({ className }: { className?: string }) {
  const { lang, setLang } = useI18n();

  return (
    <div
      role="group"
      aria-label="Language"
      className={cn(
        'inline-flex h-8 items-center rounded-md border bg-muted/40 p-0.5',
        className,
      )}
    >
      {(['en', 'ar'] as const).map((code) => (
        <button
          key={code}
          type="button"
          onClick={() => setLang(code)}
          aria-pressed={lang === code}
          className={cn(
            'inline-flex h-7 min-w-9 items-center justify-center rounded-[5px] px-2 text-xs font-medium transition-colors',
            lang === code
              ? 'bg-background text-foreground shadow-xs'
              : 'text-muted-foreground hover:text-foreground',
          )}
        >
          {code === 'en' ? 'EN' : 'ع'}
        </button>
      ))}
    </div>
  );
}
